

































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { TabModel } from '@/components/tabs/tab-model';
import { successButtonColorClass } from '@/utlitities/color';
import { UserStore } from '@/store/user-module';

@Component({
  components: {},
})
export default class StTabs extends Vue {
  @Prop() tabs!: TabModel[];
  @Prop() value!: string;
  @Prop({ default: false }) renderForSingleTab!: boolean;
  @Prop() loading!: boolean;
  @Prop() delayLoading!: boolean;

  get activeTab() {
    return this.value;
  }

  get successButtonColor() {
    return successButtonColorClass(UserStore.userSettings.successButtonColor);
  }

  changeTab(tab: TabModel) {
    if (!tab.Disabled) {
      this.$emit('input', tab.TabName);
    }
  }
}
